import * as React from "react";

import type { LucideIcon } from "lucide-react";

import { cn } from "@/shared/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  startIcon?: LucideIcon;
  endIcon?: LucideIcon;
  optional?: boolean;
  containerClassName?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      type,
      startIcon,
      endIcon,
      optional,
      containerClassName,
      ...props
    },
    ref,
  ) => {
    const StartIcon = startIcon;
    const EndIcon = endIcon;

    return (
      <div className={cn("relative flex", containerClassName)}>
        {StartIcon && (
          <div className="absolute left-1.5 top-1/2 -translate-y-1/2 transform">
            <StartIcon
              size={18}
              className="text-muted-foreground text-textColor"
            />
          </div>
        )}
        <input
          type={type}
          className={cn(
            "ring-offset-background focus-visible:ring-ring flex h-10 w-full rounded-md border border-strokeColor bg-bgColor px-4 py-2 text-sm text-textColor file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-neutral-500 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50",
            startIcon ? "pl-8" : "",
            endIcon ? "pr-8" : "",
            optional ? "pr-28" : "",
            className,
          )}
          ref={ref}
          {...props}
        />
        {EndIcon && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2 transform">
            <EndIcon
              className="text-muted-foreground text-textColor"
              size={18}
            />
          </div>
        )}
        {optional && (
          <span className="absolute right-4 top-1/2 -translate-y-1/2 text-xs text-textGrayColor">
            Опционально
          </span>
        )}
      </div>
    );
  },
);
Input.displayName = "Input";

export { Input };
